<template>
  <div class="column full-height full-weight">
    <div
      class="col q-px-sm q-py-xs bg-white"
      style="position: relative"
    >
      <div
        class="column full-height full-weight"
        v-if="email"
      >
        <div class="col-auto row">
          <div class="col">
            <FieldSelect
              data-testid="email-acao-atendimento"
              :disabled="isDisabled"
              v-if="email.emailParentId"
              :list="answerOptions"
              placeholder="Acão do Atendimento"
              v-model="email.answerOption"
            />
            <FieldSelect
              data-testid="email-conta"
              :disabled="isDisabled"
              v-if="!email.emailParentId"
              :list="emailConfigOptions"
              placeholder="Conta de Email"
              v-model="email.botId"
            />
          </div>

          <div
            class="col-5 q-pl-sm"
            v-if="showTransferQueues"
          >
            <FieldSelect
              data-testid="email-fila-transferencia"
              :disabled="isDisabled"
              placeholder="Fila de Transferência"
              :list="transferQueues"
              v-model="email.transferQueueId"
            />
          </div>

          <AskAgentTransfer
            v-if="showTransferAgents"
            v-model="showTransferAgents"
            @cancel="clearSelection"
            @agent-selected="handleAgentSelected"
          />

          <q-chip
            data-testid="email-transferencia-selecionada"
            square
            outline
            color="primary"
            :removable="email.status !== 'TRANSFERRED'"
            @remove="clearSelection"
            :label="`${email.selectedAgent} - ${email.selectedQueue}`"
            class="col-5 q-mt-md selected-chip"
            v-if="email.selectedQueue && email.selectedAgent"
          >
            <q-tooltip> {{ email.selectedAgent }} - {{ email.selectedQueue }}</q-tooltip>
          </q-chip>
        </div>

        <div
          class="col-auto q-py-xs"
          v-if="canWrite"
        >
          <FieldEmails
            data-testid="email-para"
            :disabled="isDisabled"
            v-if="email"
            label="Para"
            v-model="email.to"
          />
        </div>

        <div
          class="col-auto q-py-xs"
          v-if="canWrite"
        >
          <FieldEmails
            data-testid="email-copia"
            :disabled="isDisabled"
            v-if="email"
            label="Cópia"
            v-model="email.cc"
          />
        </div>

        <div class="col-auto q-py-xs">
          <div
            class="row items-center"
          >
            <div :class="[currentMessageId[attendanceId]? 'col-8': 'col-9']">
              <FieldText
                data-testid="email-assunto"
                :disabled="isDisabled || !canWrite"
                v-if="email"
                preparend-text="Assunto"
                v-model="email.subject"
              />
            </div>
            <div
              class="row justify-around"
              :class="[currentMessageId[attendanceId]? 'col-4': 'col-3']"
              style="max-height: 30px"
            >
              <q-btn
                data-testid="email-abrir-perfilador"
                v-if="currentMessageId[attendanceId]"
                flat
                no-caps
                padding="0px"
                class="cursor-pointer"
                icon="mdi-clipboard-edit-outline"
                @click="openProfilerCurrent"
                text-color="primary"
              >
                <q-tooltip>Abrir perfilador</q-tooltip>
              </q-btn>

              <q-btn
                data-testid="email-abrir-agenda"
                flat
                no-caps
                padding="0px"
                class="col-auto q-ml-xs"
                icon="mdi-calendar"
                text-color="primary"
                @click="openCalendar"
              >
                <q-tooltip>Abrir agenda</q-tooltip>
              </q-btn>

              <q-btn
                data-testid="email-anexar"
                flat
                no-caps
                padding="0"
                class="cursor-pointer"
                v-if="!isDisabled && !isSending && canWrite"
              >
                <label class="cursor-pointer q-px-sm q-pt-xs">
                  <PaperclipIcon />
                  <q-tooltip>Anexar Arquivos</q-tooltip>
                  <q-file
                    data-testid="email-anexar-arquivo"
                    class="hidden"
                    :multiple="true"
                    v-model="files"
                    :max-total-size="1024 * 1024 * 30"
                  />
                </label>
              </q-btn>

              <q-btn
                data-testid="email-descartar"
                flat
                no-caps
                padding="0px"
                class="cursor-pointer"
                v-if="!isDisabled && !email.emailParentId"
                @click="dropTextAttendance(attendanceId)"
              >
                <TrashIcon />
                <q-tooltip>Descartar</q-tooltip>
              </q-btn>

              <q-btn
                data-testid="email-descartar-rascunho"
                flat
                no-caps
                padding="0px"
                class="cursor-pointer"
                :disable="disableSketchButton"
                v-if=" isSentOutEmail && !isDisabled"
                @click="dropSketchTextMessage(attendanceId)"
              >
                <TrashIcon />
                <q-tooltip>Descartar rascunho</q-tooltip>
              </q-btn>

              <q-btn
                data-testid="email-enviar"
                flat
                no-caps
                padding="0px"
                class="cursor-pointer"
                v-if="!isDisabled"
                :loading="attendance.loading"
                :disable="isRevising"
                @click="sendEmail"
              >
                <SendIcon />
                <q-tooltip>Enviar</q-tooltip>
              </q-btn>

              <q-btn
                data-testid="email-revisar-ia"
                flat
                no-caps
                padding="0px"
                class="cursor-pointer"
                icon="mdi-auto-fix"
                text-color="primary"
                v-if="canShowRevisionButton"
                :loading="isRevising"
                :disable="isRevising"
                @click="handleReviseEmail"
              >
                <q-tooltip v-if="!isRevising">
                  Revisar email com IA
                </q-tooltip>
              </q-btn>
            </div>
          </div>
        </div>

        <div
          ref="editortollbar"
          class="col-auto q-pt-xs"
          v-show="!isDisabled && canWrite"
        />

        <div
          v-if="show"
          class="col"
        >
          <q-scroll-area :style="contentyStyle">
            <div
              v-if="isDisabled && canWrite"
              v-html="email.message"
              class="q-px-sm mail-body"
            />

            <FieldEditor
              data-testid="email-mensagem"
              ref="fieldEditor"
              v-else-if="canWrite"
              :target-toolbar="refToolbar"
              v-model="email.message"
            />

            <q-list
              dense
              class="rounded-borders"
            >
              <template v-for="(message, index) in email.messages">
                <AttendanceMailItem
                  @click-open-profiler="(labelMessage) => openProfiler(message, labelMessage)"
                  :key="message.id"
                  :default-opened="!index"
                  :message="message"
                >
                  <template
                    #prefix-head
                    v-if="showRadio(message)"
                  >
                    <q-radio
                      :data-testid="`email-responder-${message.id}`"
                      dense
                      keep-color
                      name="emailParentId"
                      v-model="email.emailParentId"
                      checked-icon="mdi-send-circle-outline"
                      unchecked-icon="mdi-checkbox-blank-circle-outline"
                      color="primary"
                      :val="message.id"
                    />
                  </template>
                </AttendanceMailItem>
              </template>
            </q-list>
          </q-scroll-area>
        </div>

        <div
          v-if="!isDisabled && canWrite && hasItems(email.attachments)"
          class="col-auto q-pt-md"
        >
          <span style="color: #263236; font-size: 12px; font-weight: 500;">ENVIAR ANEXOS</span>
          <q-scroll-area
            horizontal
            style="
              height: 100px;
              width: 100%;
              border-top: 1px solid #CDDCE5;
              border-radius: 4px;
              padding: 6px 8px;
            "
            :bar-style="bottomBarScroll"
            :thumb-style="bottomThumbScroll"
          >
            <div
              class="row items-center no-wrap"
              style="min-height: 85px; height: 85px"
            >
              <template v-for="attach in email.attachments">
                <FieldAttachment
                  :attach="attach"
                  :key="attach.id"
                  :readonly="isDisabled"
                  @on-remove="dropAttach(attach)"
                />
              </template>
            </div>
          </q-scroll-area>
        </div>

        <div
          v-if="hasItems(oldAttachments)"
          class="col-auto q-pt-md"
        >
          <span style="color: #263236; font-size: 12px; font-weight: 500">PAINEL DE VISUALIZAÇÃO DE DOCUMENTOS</span>
          <q-scroll-area
            horizontal
            style="
              height: 100px;
              width: 100%;
              border-top: 1px solid #CDDCE5;
              border-radius: 4px;
              padding: 6px 8px;
            "
            :bar-style="bottomBarScroll"
            :thumb-style="bottomThumbScroll"
          >
            <div
              class="row items-center no-wrap"
              style="min-height: 85px; height: 85px"
            >
              <template v-for="attach in oldAttachments">
                <FieldAttachment
                  :attach="attach"
                  :key="attach.id"
                  readonly
                  show-checkbox
                  desc-checkbox="Reenviar Anexo"
                  :is-checked="resendAttaches.includes(attach.id)"
                  @check="(isChecked) => checkReAttach(attach.id, isChecked)"
                />
              </template>
            </div>
          </q-scroll-area>
        </div>
      </div>
    </div>

    <q-inner-loading :showing="attendance.loading || !email">
      <q-spinner-ios
        size="50px"
        color="primary"
      />
    </q-inner-loading>

    <q-dialog
      persistent
      v-model="attendance.wasUpdated"
      transition-show="scale"
      transition-hide="scale"
    >
      <q-card
        class="bg-primary text-white"
        style="width: 300px"
      >
        <q-card-section>
          <div class="text-h6">
            Atualização
          </div>
        </q-card-section>

        <q-card-section class="q-pt-none">
          O Histórico desse atendimento foi atualizado
        </q-card-section>

        <q-card-actions
          align="right"
          class="bg-white text-teal"
        >
          <q-btn
            data-testid="email-historico-ok"
            flat
            label="OK"
            @click="setHistoryReaded"
          />
        </q-card-actions>
      </q-card>
    </q-dialog>

    <q-dialog
      v-model="showComparisonDialog"
      persistent
    >
      <q-card style="width: 90vw; max-width: 1200px">
        <q-card-section class="row items-center">
          <div class="text-h6">
            Comparação de versões do email
          </div>
          <q-space />
          <q-btn
            data-testid="email-comparacao-fechar"
            icon="mdi-close"
            flat
            round
            dense
            @click="cancelRevision"
          />
        </q-card-section>

        <q-card-section
          v-if="isRevising"
          class="column items-center justify-center"
          style="min-height: 400px"
        >
          <q-spinner-ios
            size="50px"
            color="primary"
          />
          <div class="q-mt-md text-grey-7">
            Pensando...
          </div>
        </q-card-section>

        <q-card-section
          v-else
          style="min-height: 400px; max-height: 70vh; display: flex; flex-direction: column; overflow: hidden"
        >
          <div class="desktop-comparison">
            <div
              class="row q-col-gutter-md"
              style="height: 100%"
            >
              <div class="col-6 column">
                <div class="text-subtitle1 q-mb-md">
                  Versão original
                </div>
                <div
                  class="q-pa-sm bg-grey-2 rounded-borders"
                  style="flex: 1; overflow-y: auto"
                >
                  <div class="text-weight-bold">
                    Assunto:
                  </div>
                  <div class="q-mb-md">
                    {{ originalEmailSnapshot.subject }}
                  </div>
                  <div class="text-weight-bold">
                    Mensagem:
                  </div>
                  <div v-html="originalEmailSnapshot.message" />
                </div>
              </div>

              <div class="col-6 column">
                <div class="text-subtitle1 q-mb-md">
                  Versão revisada
                </div>
                <div
                  class="q-pa-sm bg-blue-1 rounded-borders"
                  style="flex: 1; overflow-y: auto"
                >
                  <div class="text-weight-bold">
                    Assunto:
                  </div>
                  <div class="q-mb-md">
                    {{ revisedEmail.subject }}
                  </div>
                  <div class="text-weight-bold">
                    Mensagem:
                  </div>
                  <div v-html="revisedEmail.message" />
                </div>
              </div>
            </div>
          </div>

          <div class="mobile-comparison">
            <q-tabs
              v-model="activeComparisonTab"
              dense
              class="comparison-tabs"
              active-color="primary"
              indicator-color="primary"
              align="justify"
            >
              <q-tab
                data-testid="email-comparacao-aba-original"
                name="original"
                label="Original"
              />
              <q-tab
                data-testid="email-comparacao-aba-revisada"
                name="revised"
                label="Revisada"
              />
            </q-tabs>

            <div class="tab-content-container">
              <div
                v-show="activeComparisonTab === 'original'"
                class="tab-content"
              >
                <div class="text-subtitle1 q-mb-md">
                  Versão original
                </div>
                <div class="content-scroll q-pa-sm bg-grey-2 rounded-borders">
                  <div class="text-weight-bold">
                    Assunto:
                  </div>
                  <div class="q-mb-md">
                    {{ originalEmailSnapshot.subject }}
                  </div>
                  <div class="text-weight-bold">
                    Mensagem:
                  </div>
                  <div v-html="originalEmailSnapshot.message" />
                </div>
              </div>

              <div
                v-show="activeComparisonTab === 'revised'"
                class="tab-content"
              >
                <div class="text-subtitle1 q-mb-md">
                  Versão revisada
                </div>
                <div class="content-scroll q-pa-sm bg-blue-1 rounded-borders">
                  <div class="text-weight-bold">
                    Assunto:
                  </div>
                  <div class="q-mb-md">
                    {{ revisedEmail.subject }}
                  </div>
                  <div class="text-weight-bold">
                    Mensagem:
                  </div>
                  <div v-html="revisedEmail.message" />
                </div>
              </div>
            </div>
          </div>

          <div
            class="row q-col-gutter-md q-mt-md"
            style="flex-shrink: 0"
          >
            <div class="col-6">
              <q-btn
                data-testid="email-usar-original"
                color="grey"
                label="Usar Original"
                @click="keepOriginalVersion"
                class="full-width"
              />
            </div>
            <div class="col-6">
              <q-btn
                data-testid="email-usar-revisada"
                color="primary"
                label="Usar Revisada"
                @click="applyRevisedVersion"
                class="full-width"
              />
            </div>
          </div>
        </q-card-section>
      </q-card>
    </q-dialog>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import FieldText from '@/components/FieldText'
import FieldEmails from '@/components/FieldEmails'
import FieldSelect from '@/components/FieldSelect'
import SendIcon from '@/assets/icons/send.svg'
import TrashIcon from '@/assets/icons/trash.svg'
import PaperclipIcon from '@/assets/icons/paperclip.svg'
import { Notify } from 'quasar'
import FieldAttachment from '@/components/FieldAttachment'
import AskAgentTransfer from './AskAgentTransfer'
import AttendanceMailItem from './AttendanceMailItem'
import { parseJson } from '@/libs/helpers'
import api from '@/libs/api'

const FieldEditor = () => import(/* webpackChunkName: "ComponentsFieldEditor" */ '@/components/FieldEditor')

const answerOptions = [
  { id: 'onlyAnswer', label: 'Responder atendimento' },
  { id: 'answerFinish', label: 'Responder e finalizar atendimento' },
  // { id: 'answerTransfer', label: 'Responder e Transferir Atendimento' },
  { id: 'onlyTransfer', label: 'Transferir atendimento para uma fila' },
  { id: 'agentTransfer', label: 'Transferir atendimento para um agente' },
  { id: 'onlyFinish', label: 'Finalizar atendimento' },
  { id: 'onlyGiveBack', label: 'Devolver atendimento para fila de espera' }
]

export default {
  components: {
    FieldText,
    FieldEmails,
    FieldEditor,
    SendIcon,
    FieldSelect,
    TrashIcon,
    PaperclipIcon,
    FieldAttachment,
    AskAgentTransfer,
    AttendanceMailItem
  },

  props: {
    attendanceId: {}
  },

  data () {
    const refToolbar = null
    const email = initialMail()
    const resendAttaches = []

    return {
      email,
      show: true,
      files: null,
      showTransferAgents: false,
      refToolbar,
      resendAttaches,
      answerOptions,
      bottomBarScroll,
      bottomThumbScroll,
      disableSketchButton: true,
      isRevising: false,
      revisionCancelled: false,
      showComparisonDialog: false,
      revisedEmail: { subject: '', message: '' },
      originalEmailSnapshot: { subject: '', message: '' },
      activeComparisonTab: 'revised'
    }
  },

  mounted () {
    const vm = this
    vm.elMounted = true

    vm.$nextTick().then(() => {
      if (!vm.elMounted) return
      vm.refToolbar = vm.$refs.editortollbar
      vm.email = cloneAttendance(vm.attendance || initialMail(), vm.emailConfigs)
      vm.disableSketchButton = vm.isSketching()

      vm.$nextTick().then(() => {
        if (!vm.elMounted) return
        vm.checkRefreshMessages()
      })
    })
  },

  beforeDestroy () {
    const vm = this
    vm.elMounted = false
  },

  computed: {
    ...mapGetters({
      agent: 'agentModule/getAgent',
      emailConfigs: 'agentModule/getEmailConfigs',
      allEmailConfigs: 'agentModule/getAllEmailConfigs',
      currentMessageId: 'attendanceModule/currentMessageId'
    }),

    ...mapState({
      attendance ({ attendanceModule }) {
        const vm = this
        const { history, current } = attendanceModule
        const attendance = Object.assign({}, current[vm.attendanceId] || history[vm.attendanceId] || {})
        if (!attendance.botId) attendance.botId = vm.emailConfigOptions[0]?.id
        return attendance
      }
    }),

    thereIsMessage () {
      return Boolean(
        this.email.message
          .replaceAll('<p>', '')
          .replaceAll('</p>', '')
          .replaceAll('<div>', '')
          .replaceAll('</div>', '')
          .replaceAll('<span>', '')
          .replaceAll('</span>', '')
          .replaceAll('-', '')
          .replaceAll('<br>', '')
          .replaceAll('<br/>', '')
          .replace(/\n/g, '')
          .replace(/\r/g, '')
          .replace(/&nbsp;/g, '')
          .trim())
    },
    emailConfigOptions () {
      const emailConfigs = Array.isArray(this.emailConfigs) ? this.emailConfigs : []
      return emailConfigs.map(({ id, name }) => ({ id, label: name }))
    },

    transferQueues () {
      const { queueId } = this.attendance
      const allEmailConfigs = Array.isArray(this.allEmailConfigs) ? this.allEmailConfigs : []
      return allEmailConfigs.filter((item) => item.queueId !== queueId).map(({ queueId, queueName }) => ({ id: queueId, label: queueName }))
    },

    showTransferQueues () {
      return ['answerTransfer', 'onlyTransfer'].includes(this.email.answerOption)
    },

    canShowAgents () {
      return ['agentTransfer'].includes(this.email.answerOption)
    },

    isDisabled () {
      return ['FINISHED', 'AUTO_CLOSE', 'OFFERING', 'TRANSFERRED'].includes(this.email?.status)
    },

    canWrite () {
      const answerOption = this.email?.answerOption ?? 'onlyAnswer'
      return ['onlyAnswer', 'answerFinish', 'answerTransfer'].includes(answerOption)
    },

    isSending () {
      return this.email?.status === 'SEND_PENDING'
    },

    canShowRevisionButton () {
      if (!(!this.isDisabled && this.canWrite && !this.isSending)) {
        return false
      }

      const currentEmailConfig = this.emailConfigs.find(config => config.id === this.email.botId)
      if (!currentEmailConfig) return false

      return currentEmailConfig.enableEmailAi === 'yes'
    },

    contentyStyle () {
      if (this.isDisabled) return 'height: 100%; width: 100%; border: 1px dashed #cacaca; border-radius: 2px'
      return 'height: 100%; width: 100%; border-left: 1px solid #cacaca; border-right: 1px solid #cacaca; border-bottom: 1px solid #cacaca; border-radius: 2px'
    },

    oldAttachments () {
      const oldAttachments = Array.isArray(this.email?.oldAttachments) ? [...this.email.oldAttachments] : []
      const attachments = this.isDisabled && Array.isArray(this.email?.attachments) ? [...this.email.attachments] : []
      return attachments.concat(oldAttachments)
    },

    transferToAgent () {
      return Boolean(
        ['agentTransfer'].includes(this.email.answerOption) && this.email.transferAgentId
      )
    },

    isSentOutEmail () {
      if (['PREPARING'].includes(this.email.status)) return false
      let isSentOutEmail = this.email.direction === 'OUT'

      if (this.email.messages?.length) {
        const messages = this.email.messages
        const firstMessage = messages[0]
        isSentOutEmail = firstMessage.direction === 'OUT'
      }

      return isSentOutEmail
    }
  },

  methods: {
    ...mapActions({
      sendMail: 'socketModule/sendMail',
      startUpload: 'attendanceModule/startUpload',
      setHistoryKnow: 'attendanceModule/setHistoryKnow',
      updateAttendance: 'attendanceModule/updateAttendance',
      updateHistoryMail: 'attendanceModule/updateHistoryMail',
      dropTextAttendance: 'attendanceModule/dropTextAttendance',
      dropSketchTextMessage: 'attendanceModule/dropSketchTextMessage'
    }),

    dropAttach (attach) {
      const vm = this
      const attachments = vm.email.attachments.filter((item) => item.id !== attach.id)
      vm.email = Object.assign({}, vm.email, { attachments })
    },

    isSketching () {
      if (!this.email.message) return true
      const canSketch = ['onlyAnswer', 'answerFinish'].includes(this.email.answerOption)
      if (!canSketch) return true

      const noAttachments = !(this.email.attachments?.length > 0)
      const notAnswering = this.email.status !== 'ANSWERING'
      const noMessage = !this.thereIsMessage

      const shouldDisableButton = noMessage && noAttachments && notAnswering
      return shouldDisableButton
    },

    showRadio (message) {
      if (!message) return false
      if (this.email?.emailParentId === message?.id) return true
      return !this.isDisabled
    },

    checkRefreshMessages () {
      const vm = this

      const canLoadMessages = !vm.email.loadStatus || vm.email.loadStatus === 'ERROR'
      if (canLoadMessages) return vm.updateHistoryMail(vm.email.id)
      const hasSendPending = Array.isArray(vm.email.messages) && Date.now() > (vm.email.loadedAt + 5000) && Boolean(vm.email.messages.find(({ status }) => ['SEND_PENDING', 'SEND_FAILED'].includes(status)))
      if (hasSendPending) return vm.updateHistoryMail(vm.email.id)
    },

    setHistoryReaded () {
      this.setHistoryKnow(this.attendance.id)
    },

    openProfiler (message, labelMessage) {
      const profilerSelected = {
        messageId: this.handleProfilerMail(message),
        labelMessage
      }
      this.$emit('open-profiler', true, profilerSelected)
    },

    openProfilerCurrent () {
      const { id } = this.currentMessageId[this.attendanceId]
      const profilerSelected = {
        messageId: { agentEmailMessageId: id },
        labelMessage: 'Última mensagem enviada'
      }
      this.$emit('open-profiler', true, profilerSelected)
    },

    handleProfilerMail (message) {
      const { id, direction } = message
      const isMsgAgent = direction === 'OUT'

      return isMsgAgent ? { agentEmailMessageId: id } : { contactEmailMessageId: id }
    },

    checkReAttach (attachId, canAttach) {
      const resendAttaches = Array.isArray(this.resendAttaches)
        ? [...this.resendAttaches]
        : []
      const hasAttach = resendAttaches.includes(attachId)
      if (canAttach && hasAttach) return
      if (!canAttach && !hasAttach) return
      if (!canAttach) resendAttaches.splice(resendAttaches.indexOf(attachId), 1)
      if (canAttach) resendAttaches.push(attachId)
      this.resendAttaches = resendAttaches
    },

    validateEmail () {
      if (!this.email.botId) {
        this.notificate('Informe a conta de origem do envio')
        return false
      }

      if (!this.email.to.length) {
        this.notificate('Informe o E-mail de destino')
        return false
      }

      if (!this.email.subject) {
        this.notificate('Informe o assunto')
        return false
      }

      if (!this.email.message || !this.thereIsMessage) {
        this.notificate('O corpo da mensagem está vazia')
        return false
      }

      return true
    },

    sendEmail () {
      const vm = this
      const botMail = this.emailConfigs.find(({ id }) => this.email.botId === id)
      const botMailConfigs = parseJSON(botMail?.mail)
      if (botMailConfigs) vm.email.mailFrom = botMailConfigs.imapUsername
      if (vm.attendance.loading) return
      if (vm.canWrite && !vm.validateEmail()) return
      const resendAttaches = Array.isArray(vm.resendAttaches) ? [...vm.resendAttaches] : []
      const attachments = Array.isArray(vm.email.attachments) ? [...vm.email.attachments] : []
      const oldAttachments = Array.isArray(vm.email.oldAttachments) ? [...vm.email.oldAttachments] : []
      if (resendAttaches.length) {
        attachments.push(
          ...resendAttaches.map((attachId) =>
            oldAttachments.find(({ id }) => id === attachId)
          )
        )
      }
      vm.sendMail({ ...vm.email, attachments })
    },

    notificate (caption) {
      Notify.create({
        message: 'Dados inválidos',
        caption,
        position: 'right',
        actions: [{ label: 'X', color: 'white' }],
        progress: true
      })
    },

    onFiles (files) {
      const vm = this
      const attendanceId = vm.attendanceId
      if (files?.length) vm.startUpload({ attendanceId, files })
      vm.files = null
    },

    hasItems (arr) {
      return Boolean(Array.isArray(arr) && arr.length)
    },

    handleAgentSelected ({ agentId, queueId, agentName, queueName }) {
      const vm = this
      const newEmail = clone(vm.email)
      newEmail.selectedAgent = agentName
      newEmail.selectedQueue = queueName
      newEmail.transferAgentId = agentId
      newEmail.transferQueueId = queueId
      vm.email = newEmail
    },

    clearSelection () {
      if (this.email.answerOption === 'agentTransfer') this.email.answerOption = null
      this.email.transferQueueId = null
      this.email.transferAgentId = null
      this.email.selectedAgent = null
      this.email.selectedQueue = null
    },

    openCalendar () {
      this.$router.push({
        name: 'ROUTE_CALENDAR',
        query: { attendance: JSON.stringify(this.email), onlyCreate: true }
      })
    },

    canReviseEmail () {
      return this.thereIsMessage
    },

    async handleReviseEmail () {
      const vm = this

      if (!vm.canReviseEmail()) {
        vm.notificate('O corpo da mensagem está vazia')
        return
      }

      if (!vm.email.subject?.trim()) {
        vm.notificate('Informe o assunto')
        return
      }

      vm.isRevising = true
      vm.revisionCancelled = false
      vm.originalEmailSnapshot = {
        subject: vm.email.subject,
        message: vm.email.message
      }
      vm.revisedEmail = { subject: '', message: '' }
      vm.showComparisonDialog = true

      try {
        const timeoutPromise = new Promise((resolve, reject) => {
          setTimeout(() => reject(new Error('TIMEOUT')), 30000)
        })

        const revised = await Promise.race([
          api.postEmailReview({
            subject: vm.email.subject,
            draftEmail: vm.email.message,
            originalEmail: vm.originalMessage,
            agentId: vm.agent?.id
          }),
          timeoutPromise
        ])

        if (vm.revisionCancelled) return

        if (!revised?.subject || !revised?.message) {
          throw new Error('INVALID_RESPONSE')
        }

        vm.revisedEmail = {
          subject: revised.subject,
          message: revised.message
        }
      } catch (error) {
        if (vm.revisionCancelled) return

        vm.showComparisonDialog = false
        let message = 'Erro ao revisar email. Tente novamente.'

        if (error.message === 'TIMEOUT') {
          message = 'Tempo esgotado ao revisar email. Tente novamente.'
        } else if (error.message === 'INVALID_RESPONSE') {
          message = 'Resposta inválida do serviço de revisão'
        }

        vm.notificate(message)
        console.error('Email revision error:', error)
      } finally {
        vm.isRevising = false
      }
    },

    applyRevisedVersion () {
      const vm = this
      vm.email.subject = vm.revisedEmail.subject

      if (vm.$refs.fieldEditor && vm.$refs.fieldEditor.setContentPreservingUndo) {
        vm.$refs.fieldEditor.setContentPreservingUndo(vm.revisedEmail.message)
      } else {
        vm.email.message = vm.revisedEmail.message
      }
      vm.showComparisonDialog = false
    },

    keepOriginalVersion () {
      this.showComparisonDialog = false
    },

    cancelRevision () {
      this.revisionCancelled = true
      this.isRevising = false
      this.showComparisonDialog = false
    }
  },

  watch: {
    files: {
      deep: true,
      handler (files) {
        const vm = this
        const hasFiles = Array.isArray(files) && files.length
        if (!hasFiles) return
        vm.$nextTick().then(() => vm.onFiles([].concat(files)))
      }
    },

    email: {
      deep: true,
      handler (newEmail, oldEmail) {
        const vm = this
        const newId = String(newEmail?.id || newEmail?.temporaryId || '').trim()
        const oldId = String(oldEmail?.id || oldEmail?.temporaryId || '').trim()

        if (newId !== oldId) {
          vm.show = false

          vm.$nextTick().then(() => {
            setTimeout(() => {
              vm.show = true
            }, 100)
          })
        }
        vm.disableSketchButton = vm.isSketching()
        if (isEqual(newEmail, vm.attendance)) return
        vm.updateAttendance(clone(newEmail))
      }
    },

    attendance: {
      deep: true,
      handler (attendance) {
        const vm = this
        if (isEqual(attendance, vm.email)) return
        vm.email = cloneAttendance(attendance, vm.emailConfigs)
        vm.$nextTick().then(() => vm.checkRefreshMessages)
      }
    },

    showTransferQueues: {
      deep: true,
      handler (showTransferQueues) {
        const isAgentTransfer = this.email.answerOption === 'agentTransfer'

        if (!showTransferQueues && !isAgentTransfer) {
          this.email.transferQueueId = null
          return
        }

        if (!this.email.transferQueueId && this.transferQueues?.length) {
          this.email.transferQueueId = this.transferQueues[0].id
        }
      }
    },

    'email.answerOption' (option) {
      const isAgentTransfer = option === 'agentTransfer'
      const isFinished = ['FINISHED', 'AUTO_CLOSE', 'TRANSFERRED'].includes(this.email.status)
      this.showTransferAgents = isAgentTransfer && !this.email.transferAgentId && !isFinished
      if (!isAgentTransfer) this.clearSelection()
    }
  }
}

const cloneAttendance = (data, bots) => {
  const botList = Array.isArray(bots) ? bots : []
  const attendance = clone(data)

  let bot = botList.find(({ id }) => id === data.botId)
  if (!bot) bot = botList.at(0)

  const config = typeof bot?.mail === 'string' ? parseJson(bot.mail) : bot?.mail

  if (!Array.isArray(attendance.cc)) attendance.cc = []
  if (!Array.isArray(attendance.to)) attendance.to = []

  if (config) {
    attendance.botId = bot.id
    attendance.cc = attendance.cc.filter(({ id }) => ![config.smtpUsername, config.smtpSender].includes(id))
    attendance.to = attendance.to.filter(({ id }) => ![config.smtpUsername, config.smtpSender].includes(id))
  }

  return attendance
}

const clone = (val) => JSON.parse(JSON.stringify(val))
const isEqual = (val1, val2) => JSON.stringify(val1) === JSON.stringify(val2)

const thumbStyle = {
  borderRadius: '3px',
  backgroundColor: '#027be3',
  opacity: 0.75
}

const barStyle = {
  borderRadius: '3px',
  backgroundColor: '#027be3',
  opacity: 0.2
}

const horizontalThumbStyle = { ...thumbStyle, height: '3px' }
const horizontalBarStyle = { ...barStyle, height: '5px' }
const bottomBarScroll = { ...horizontalBarStyle, bottom: 0 }
const bottomThumbScroll = { ...horizontalThumbStyle, bottom: 0 }

const initialMail = () => ({
  to: [],
  cc: [],
  suject: '',
  message: '<div>Escrever o corpo do Email Aqui!</div>',
  messages: [],
  attachments: [],
  oldAttachments: []
})

const parseJSON = (str) => {
  try {
    return JSON.parse(str)
  } catch (error) {
    return false
  }
}

</script>

<style lang="sass" scoped>
.selected-chip
  display: flex
  align-items: center
  white-space: nowrap
  overflow: hidden
  margin: 0 0 0 5px
  padding: 0 14px 0 5px
  .q-chip__icon--remove
    margin-right: none

.comparison-tabs
  margin-bottom: 16px
  background: #f8f9fa
  border-radius: 8px
  padding: 4px

.comparison-tabs .q-tab
  font-weight: 600
  font-size: 14px
  min-height: 44px
  border-radius: 6px
  margin: 2px
  transition: all 0.3s ease
  text-transform: none

.comparison-tabs .q-tab--active
  background: white
  color: #1976d2
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1)

.comparison-tabs .q-tab:not(.q-tab--active)
  color: #666
  background: transparent

.comparison-tabs .q-tab:not(.q-tab--active):hover
  background: rgba(255, 255, 255, 0.5)
  color: #1976d2

.desktop-comparison
  display: block
  flex: 1
  overflow: hidden
  height: 100%

.mobile-comparison
  display: none
  flex: 1
  flex-direction: column
  overflow: hidden

.tab-content-container
  flex: 1
  overflow: hidden

.tab-content
  height: 100%
  display: flex
  flex-direction: column

.content-scroll
  flex: 1
  overflow-y: auto
  max-height: calc(70vh - 200px)

@media (max-width: 1200px)
  .desktop-comparison
    display: none !important

  .mobile-comparison
    display: flex !important

@media (min-width: 1201px)
  .desktop-comparison .col-6 .bg-grey-2,
  .desktop-comparison .col-6 .bg-blue-1
    max-height: calc(70vh - 150px)
</style>
